// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .fade-enter {
  opacity: 0.01;
}

.fade-enter-active {
  opacity: 1;
  transition: opacity 500ms ease-in;
}

.fade-exit {
  opacity: 1;
}

.fade-exit-active {
  opacity: 0.01;
  transition: opacity 300ms ease-in;
} */


.text {
  margin-bottom: 20px;
  font-size: 20px;
  font-weight: 700;
}

.fade-enter {
  opacity: 0;
}

.fade-enter-active {
  opacity: 1;
  transition: opacity 300ms cubic-bezier(0.55, 0.085, 0.68, 0.53);
}

.fade-exit {
  opacity: 1;
}

.fade-exit-active {
  opacity: 0;
  transition: opacity 200ms cubic-bezier(0.25, 0.46, 0.45, 0.94);
}
`, "",{"version":3,"sources":["webpack://./src/screens/landing/components/TextFader.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;GAgBG;;;AAGH;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,+DAA+D;AACjE;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,8DAA8D;AAChE","sourcesContent":["/* .fade-enter {\n  opacity: 0.01;\n}\n\n.fade-enter-active {\n  opacity: 1;\n  transition: opacity 500ms ease-in;\n}\n\n.fade-exit {\n  opacity: 1;\n}\n\n.fade-exit-active {\n  opacity: 0.01;\n  transition: opacity 300ms ease-in;\n} */\n\n\n.text {\n  margin-bottom: 20px;\n  font-size: 20px;\n  font-weight: 700;\n}\n\n.fade-enter {\n  opacity: 0;\n}\n\n.fade-enter-active {\n  opacity: 1;\n  transition: opacity 300ms cubic-bezier(0.55, 0.085, 0.68, 0.53);\n}\n\n.fade-exit {\n  opacity: 1;\n}\n\n.fade-exit-active {\n  opacity: 0;\n  transition: opacity 200ms cubic-bezier(0.25, 0.46, 0.45, 0.94);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
